import React, { useState, useEffect } from 'react'
import Button from '../Buttons/Button';
export const SimpleNumberInput = ({ value = 0, onChange, min = 0, max = 100, step = 1 }) => {
    const [inputValue, setInputValue] = useState(value || 0);
    const handleChange = (value) => {
        const newValue = parseFloat(value);
        if (!isNaN(newValue) && newValue >= min && newValue <= max) {
            setInputValue(newValue);
            onChange(newValue);
        }
    }
    return (
        <div className="flex flex-row gap-1 h-fit items-center">
            <Button text={"-"} buttonColor='transparent' borderStyle='rounded-full border border-black' onClickAction={() => handleChange(Math.max(inputValue - step, min))} />
            <div className="rounded-full border border-black flex items-center justify-center bg-white p-2">
                {inputValue}
            </div>
            <Button text={"+"} buttonColor='transparent' borderStyle='rounded-full border border-black' onClickAction={() => handleChange(Math.max(inputValue + step, min))} />
        </div>
    )
}